import { Dispatch, SetStateAction, useEffect } from "react";

const useResetFlagCleanup = (
  isResetClicked: boolean,
  setIsResetClicked: Dispatch<SetStateAction<boolean>>
) => {
  // Handle reset flag cleanup
  useEffect(() => {
    if (!isResetClicked) return;

    let timeoutId: NodeJS.Timeout;
    timeoutId = setTimeout(() => {
      setIsResetClicked(false);
    }, 100);

    // Cleanup timeout if component unmounts or reset is triggered again
    return () => {
      if (!timeoutId) return;
      clearTimeout(timeoutId);
    };
  }, [isResetClicked]);
};
export default useResetFlagCleanup;
